export const SET_GTM = 'src/store/googleTagManager/SET_GTM';
export const SET_DATA_BRANCH = 'src/store/googleTagManager/SET_DATA_BRANCH';
export const SET_PAGE_BRANCH = 'src/store/googleTagManager/SET_PAGE_BRANCH';
export const SET_DATA_PRODUCT = 'src/store/googleTagManager/SET_DATA_PRODUCT';
export const SET_DATA_NEW_CAR = 'src/store/googleTagManager/SET_DATA_NEW_CAR';
export const SET_DATA_QUICKLINK = 'src/store/googleTagManager/SET_DATA_QUICKLINK';
export const SET_DATA_TRENDING_CAR = 'src/store/googleTagManager/SET_DATA_TRENDING_CAR';
export const SET_FILTER_COUPON = 'src/store/googleTagManager/SET_FILTER_COUPON';
export const SET_CATEGORY_SERVICE = 'src/store/googleTagManager/SET_CATEGORY_SERVICE';
export const SET_DATA_SIMULATION_CREDIT = 'src/store/googleTagManager/SET_DATA_SIMULATION_CREDIT';
export const RESET_DATA_SIMULATION_CREDIT =
  'src/store/googleTagManager/RESET_DATA_SIMULATION_CREDIT';
export const SET_DATA_GET_ADVICE_USED_CAR =
  'src/store/googleTagManager/SET_DATA_GET_ADVICE_USED_CAR';
export const SET_IS_GTM_READY = 'src/store/googleTagManager/SET_IS_GTM_READY';
